export default "__VITE_ASSET__l3XkrjTl__"